import React from 'react';
import { ChevronLeftIcon } from 'lucide-react';
import { BankLogo } from './BankLogo';
import { OPENFINANCE_THEME, getOpenFinanceLogo } from '../../constants/openFinanceTheme';
export interface HeaderProps {
  title: string;
  context: 'TPP' | 'LFI';
  onBack?: () => void;
  showArabic?: boolean;
  bankName?: string;
  bankLogoUrl?: string;
  bankColor?: string;
  tppLogoUrl?: string;
}
export function Header({
  title,
  context,
  onBack,
  showArabic = true,
  bankName,
  bankLogoUrl,
  bankColor,
  tppLogoUrl
}: HeaderProps) {
  const isTPP = context === 'TPP';
  // Use OpenFinance-OS teal gradient for TPP, bank color for LFI
  const headerStyle = isTPP ? {
    background: OPENFINANCE_THEME.gradients.header,
    fontFamily: OPENFINANCE_THEME.fonts.body
  } : {
    background: bankColor || '#1e3a5f'
  };
  return <div className="text-white px-5 py-4 flex items-center shadow-lg" style={headerStyle} data-id="element-1653">
      <div className="flex items-center space-x-3" data-id="element-1654">
        {onBack && <button onClick={onBack} className="p-1.5 hover:bg-white/20 transition-all duration-200 active:scale-95" style={{
        borderRadius: OPENFINANCE_THEME.radius.sm
      }} aria-label="Go back" data-id="element-1655">
            <ChevronLeftIcon className="w-5 h-5" strokeWidth={2.5} data-id="element-1656" />
          </button>}
        {context === 'LFI' && bankName && bankLogoUrl ? <div className="flex items-center space-x-2" data-id="element-1657">
            <div className="w-8 h-8 overflow-hidden bg-white flex items-center justify-center p-1" style={{
          borderRadius: OPENFINANCE_THEME.radius.sm
        }} data-id="element-1658">
              <img src={bankLogoUrl} alt={bankName} className="w-full h-full object-contain" data-id="element-1659" />
            </div>
            <span className="font-bold text-sm tracking-wide" data-id="element-1660">{bankName}</span>
          </div> : context === 'TPP' ? <div className="flex items-center space-x-2" data-id="element-1661">
            <div className="w-9 h-9 bg-white/10 flex items-center justify-center p-1.5" style={{
          borderRadius: OPENFINANCE_THEME.radius.sm
        }} data-id="element-1662">
              <img src={getOpenFinanceLogo('sm')} alt="OpenFinance-OS" className="w-full h-full object-contain" data-id="element-1663" />
            </div>
            <span className="font-semibold text-sm tracking-wide" style={{
          fontFamily: OPENFINANCE_THEME.fonts.body
        }} data-id="element-1664">
              VeloX
            </span>
          </div> : <span className="font-bold text-sm tracking-wide" style={{
        fontFamily: OPENFINANCE_THEME.fonts.body
      }} data-id="element-1665">
            VeloX
          </span>}
      </div>
    </div>;
}